import { SelectOption } from '@/types/form.type.ts';

export enum CarUIFormComplectationType {
    DecodeVin = 'decode_vin',
    ComplectationCode = 'complectation_code',
    CustomComplectation = 'custom_complectation',
}

export function getCarUIFormComplectationTypeLabel(type: CarUIFormComplectationType): string {
    switch (type) {
        case CarUIFormComplectationType.DecodeVin:
            return 'VIN-декодер';
        case CarUIFormComplectationType.ComplectationCode:
            return 'Код комплектации';
        case CarUIFormComplectationType.CustomComplectation:
            return 'Своя комплектация';
    }
}

export function getCarUIFormComplectationTypeSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(CarUIFormComplectationType).forEach((type: CarUIFormComplectationType) => {
        options.push({
            label: getCarUIFormComplectationTypeLabel(type),
            value: type,
        });
    });

    return options;
}
